import { useQuery } from "@tanstack/react-query";
import React from "react";
import { useLocation } from "react-router-dom";
import { emailTopicsUrl } from "../../../configurationMenu";
import { HelmetDexteel } from "../../../helmet/HelmetDexteel";
import { TableEmailTopics } from "./components/TableEmailTopics";
import { EmailAddressTopic } from "./models/EmailAddressTopic";
import { EmailTopic } from "./models/EmailTopic";
import { getEmailTopics } from "./repositories/EmailTopicsRepository";

export const getEmailTopicRouteState = (
	pathname: string,
): { modal: "" | "create" | "update"; emailTopicId?: string } => {
	if (!pathname.startsWith(emailTopicsUrl)) {
		return { modal: "" };
	}

	const [routeValue, action] = pathname
		.slice(emailTopicsUrl.length)
		.split("/")
		.filter(Boolean);

	if (!routeValue) {
		return { modal: "" };
	}

	if (routeValue === "new") {
		return { modal: "create" };
	}

	if (action) {
		return { modal: "" };
	}

	return { modal: "update", emailTopicId: routeValue };
};

export const useEmailTopics = ({
	emailTopicId = null,
	includeInactive = false,
	includeSystem = false,
	enabled = true,
}: {
	emailTopicId?: number | null;
	includeInactive?: boolean;
	includeSystem?: boolean;
	enabled?: boolean;
} = {}) => {
	return useQuery<
		{
			topics: EmailTopic[];
			addresses: EmailAddressTopic[];
		},
		Error
	>({
		queryKey: ["emailTopics", emailTopicId, includeInactive, includeSystem],
		enabled,
		queryFn: ({ signal }) =>
			getEmailTopics({ emailTopicId, includeInactive, includeSystem }, signal),
	});
};

export const EmailTopicsPage = () => {
	const location = useLocation();
	const routeState = getEmailTopicRouteState(location.pathname);

	return (
		<>
			<HelmetDexteel title="Email Topics" />
			<TableEmailTopics
				emailTopicId={routeState.emailTopicId}
				routeModal={routeState.modal}
			/>
		</>
	);
};
